module.exports = __webpack_public_path__ + "img/klcx_04.b6c3376b.jpg";